export enum motionSensorModes {
    disabled = 'disabled',
    alwaysEnabled = 'alwaysEnabled',
    periodicallyEnabled = 'periodicallyEnabled',
}
